module.exports = __webpack_public_path__ + "img/07e9007.png";